import { render, staticRenderFns } from "./IntelytMapLegend.vue?vue&type=template&id=fef5ee1c&scoped=true&"
import script from "./IntelytMapLegend.vue?vue&type=script&lang=js&"
export * from "./IntelytMapLegend.vue?vue&type=script&lang=js&"
import style0 from "./IntelytMapLegend.vue?vue&type=style&index=0&id=fef5ee1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef5ee1c",
  null
  
)

export default component.exports